export const RECEIVE_RESIDENCY_TYPES = 'RECEIVE_RESIDENCY_TYPES';
export const GET_RESIDENCY_TYPES = 'GET_RESIDENCY_TYPES';
export const SET_RESIDENCY_TYPE = 'SET_RESIDENCY_TYPE';
export const UPDATE_RESIDENCY_TYPE = 'UPDATE_RESIDENCY_TYPE';
export const DELETE_RESIDENCY_TYPE = 'DELETE_RESIDENCY_TYPE';
export const FETCH_RESIDENCY_TYPES = 'FETCH_RESIDENCY_TYPES';
